(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meno-articles"] && !Shopify.designMode) return;
  try {
    
  const activateArticle = (root, id, focus = false) => {
    const tabs = root.querySelectorAll('[data-article-tab]');
    const panels = root.querySelectorAll('[data-article-panel]');

    tabs.forEach((tab) => {
      const active = tab.dataset.articleTab === id;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active && focus) tab.focus();
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.articlePanel !== id;
    });
  };

  document.querySelectorAll('[data-me-articles]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-article-tab]'));

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateArticle(root, tab.dataset.articleTab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        const offset = event.key === 'ArrowDown' ? 1 : -1;
        const next = tabs[(index + offset + tabs.length) % tabs.length];
        activateArticle(root, next.dataset.articleTab, true);
      });
    });
  });

  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-me-articles]');
    if (!root) return;
    activateArticle(root, event.detail.blockId);
  });

  } catch(e) { console.error(e); }
})();
})();
